import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it)
            o = it;
        var i = 0;
        var F = function F() { };
        return { s: F, n: function n() { if (i >= o.length)
                return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
} var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try {
        if (!normalCompletion && it.return != null)
            it.return();
    }
    finally {
        if (didErr)
            throw err;
    } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o)
    return; if (typeof o === "string")
    return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor)
    n = o.constructor.name; if (n === "Map" || n === "Set")
    return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length)
    len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i]; return arr2; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { store } from "@root/store";
import { Csound as Csound6 } from "@csound/browser";
import { Csound as Csound7 } from "csound7";
import { cleanupNonCloudFiles, nonCloudFiles, addNonCloudFile } from "@comp/file-tree/actions";
import { openSnackbar } from "@comp/snackbar/actions";
import { SnackbarType } from "@comp/snackbar/types";
import { SET_CSOUND_PLAY_STATE } from "./types";
import { selectActiveProject } from "@comp/projects/selectors";
import { addDocumentToEMFS } from "@comp/projects/utils";
import { getSelectedTargetDocumentUid } from "@comp/target-controls/selectors";
import { append, difference, isEmpty, path, pathOr, pipe, values } from "ramda";
export var csoundInstance;
export var setCsoundPlayState = function setCsoundPlayState(playState) {
    return {
        type: SET_CSOUND_PLAY_STATE,
        status: playState
    };
};
export var setCsound = function setCsound(csound) {
    csound.on("realtimePerformanceEnded", /*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1)
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return csound.cleanup();
                    case 3:
                        _context.next = 7;
                        break;
                    case 5:
                        _context.prev = 5;
                        _context.t0 = _context["catch"](0);
                    case 7:
                        store.dispatch(setCsoundPlayState("stopped"));
                    case 8:
                    case "end":
                        return _context.stop();
                }
        }, _callee, null, [[0, 5]]);
    })));
    csound.on("realtimePerformancePaused", function () {
        return store.dispatch(setCsoundPlayState("paused"));
    });
    csound.on("realtimePerformanceResumed", function () {
        return store.dispatch(setCsoundPlayState("playing"));
    });
    csound.on("realtimePerformanceStarted", function () {
        return store.dispatch(setCsoundPlayState("playing"));
    });
};
export var syncFs = /*#__PURE__*/ function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(csound, projectUid, storeState) {
        var documents, _iterator, _step, document, realPath, filepath;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1)
                switch (_context2.prev = _context2.next) {
                    case 0:
                        documents = pipe(pathOr({}, ["ProjectsReducer", "projects", projectUid, "documents"]), values)(storeState);
                        _iterator = _createForOfIteratorHelper(documents);
                        _context2.prev = 2;
                        _iterator.s();
                    case 4:
                        if ((_step = _iterator.n()).done) {
                            _context2.next = 12;
                            break;
                        }
                        document = _step.value;
                        // reminder: paths are store by document ref and not
                        // the actual filesystem name
                        realPath = document.path.map(function (documentId) {
                            return path(["ProjectsReducer", "projects", projectUid, "documents", documentId, "name"], storeState);
                        });
                        filepath = isEmpty(realPath) ? document.filename : realPath.join("/") + "/" + document.filename;
                        _context2.next = 10;
                        return addDocumentToEMFS(projectUid, csound, document, filepath);
                    case 10:
                        _context2.next = 4;
                        break;
                    case 12:
                        _context2.next = 17;
                        break;
                    case 14:
                        _context2.prev = 14;
                        _context2.t0 = _context2["catch"](2);
                        _iterator.e(_context2.t0);
                    case 17:
                        _context2.prev = 17;
                        _iterator.f();
                        return _context2.finish(17);
                    case 20:
                    case "end":
                        return _context2.stop();
                }
        }, _callee2, null, [[2, 14, 17, 20]]);
    }));
    return function syncFs(_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
    };
}();
export var playCsdFromFs = function playCsdFromFs(_ref3) {
    var projectUid = _ref3.projectUid, csdPath = _ref3.csdPath, useCsound7 = _ref3.useCsound7;
    return /*#__PURE__*/ function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee4(dispatch, setConsole) {
            var Csound, csoundObj, storeState, result, filesPre;
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1)
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            Csound = useCsound7 ? Csound7 : Csound6;
                            _context4.next = 3;
                            return Csound({
                                useWorker: localStorage.getItem("sab") === "true"
                            });
                        case 3:
                            csoundObj = _context4.sent;
                            if (csoundObj) {
                                _context4.next = 6;
                                break;
                            }
                            return _context4.abrupt("return");
                        case 6:
                            csoundInstance = csoundObj;
                            setCsound(csoundInstance);
                            if (csoundObj && setConsole) {
                                setConsole([""]);
                                csoundObj.on("message", function (message) {
                                    return setConsole(append(message + "\n"));
                                });
                            }
                            if (!csoundObj) {
                                _context4.next = 37;
                                break;
                            }
                            _context4.next = 12;
                            return csoundObj.setOption("-odac");
                        case 12:
                            storeState = store.getState();
                            _context4.next = 15;
                            return syncFs(csoundObj, projectUid, storeState);
                        case 15:
                            _context4.next = 17;
                            return csoundObj.compileCsd(csdPath);
                        case 17:
                            result = _context4.sent;
                            if (!(result === 0)) {
                                _context4.next = 28;
                                break;
                            }
                            _context4.next = 21;
                            return csoundObj.fs.readdir("/");
                        case 21:
                            filesPre = _context4.sent;
                            csoundObj.once("realtimePerformanceEnded", /*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee3() {
                                var filesPost, newFiles, _iterator2, _step2, newFile, buffer;
                                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                                    while (1)
                                        switch (_context3.prev = _context3.next) {
                                            case 0:
                                                _context3.next = 2;
                                                return csoundObj.fs.readdir("/");
                                            case 2:
                                                filesPost = _context3.sent;
                                                newFiles = difference(filesPost, filesPre);
                                                _iterator2 = _createForOfIteratorHelper(newFiles);
                                                _context3.prev = 5;
                                                _iterator2.s();
                                            case 7:
                                                if ((_step2 = _iterator2.n()).done) {
                                                    _context3.next = 15;
                                                    break;
                                                }
                                                newFile = _step2.value;
                                                _context3.next = 11;
                                                return csoundObj.fs.readFile(newFile);
                                            case 11:
                                                buffer = _context3.sent;
                                                if (buffer) {
                                                    nonCloudFiles.set(newFile, {
                                                        buffer: buffer,
                                                        createdAt: new Date(),
                                                        name: newFile
                                                    });
                                                    dispatch(addNonCloudFile({
                                                        createdAt: Date.now(),
                                                        name: newFile
                                                    }));
                                                }
                                            case 13:
                                                _context3.next = 7;
                                                break;
                                            case 15:
                                                _context3.next = 20;
                                                break;
                                            case 17:
                                                _context3.prev = 17;
                                                _context3.t0 = _context3["catch"](5);
                                                _iterator2.e(_context3.t0);
                                            case 20:
                                                _context3.prev = 20;
                                                _iterator2.f();
                                                return _context3.finish(20);
                                            case 23:
                                                _context3.next = 25;
                                                return syncFs(csoundObj, projectUid, storeState);
                                            case 25:
                                            case "end":
                                                return _context3.stop();
                                        }
                                }, _callee3, null, [[5, 17, 20, 23]]);
                            })));
                            _context4.next = 25;
                            return csoundObj.start();
                        case 25:
                            dispatch(setCsoundPlayState("playing"));
                            _context4.next = 37;
                            break;
                        case 28:
                            _context4.prev = 28;
                            _context4.next = 31;
                            return csoundObj.cleanup();
                        case 31:
                            _context4.next = 36;
                            break;
                        case 33:
                            _context4.prev = 33;
                            _context4.t0 = _context4["catch"](28);
                            console.error(_context4.t0);
                        case 36:
                            dispatch(setCsoundPlayState("error"));
                        case 37:
                        case "end":
                            return _context4.stop();
                    }
            }, _callee4, null, [[28, 33]]);
        }));
        return function (_x4, _x5) {
            return _ref4.apply(this, arguments);
        };
    }();
};
export var playORCFromString = function playORCFromString(_ref6) {
    var projectUid = _ref6.projectUid, orc = _ref6.orc, useCsound7 = _ref6.useCsound7;
    return /*#__PURE__*/ function () {
        var _ref7 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee5(dispatch, setConsole) {
            var Csound, csoundObj, storeState, result;
            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1)
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            Csound = useCsound7 ? Csound7 : Csound6;
                            _context5.next = 3;
                            return Csound({
                                useWorker: localStorage.getItem("sab") === "true"
                            });
                        case 3:
                            csoundObj = _context5.sent;
                            if (csoundObj) {
                                _context5.next = 6;
                                break;
                            }
                            return _context5.abrupt("return");
                        case 6:
                            csoundInstance = csoundObj;
                            setCsound(csoundInstance);
                            if (csoundObj && setConsole) {
                                setConsole([""]);
                                csoundObj.on("message", function (message) {
                                    return setConsole(append(message + "\n"));
                                });
                            }
                            if (!csoundObj) {
                                _context5.next = 33;
                                break;
                            }
                            _context5.next = 12;
                            return csoundObj.setOption("-odac");
                        case 12:
                            storeState = store.getState();
                            _context5.next = 15;
                            return syncFs(csoundObj, projectUid, storeState);
                        case 15:
                            _context5.next = 17;
                            return csoundObj.compileOrc(orc);
                        case 17:
                            result = _context5.sent;
                            if (!(result === 0)) {
                                _context5.next = 24;
                                break;
                            }
                            _context5.next = 21;
                            return csoundObj.start();
                        case 21:
                            dispatch(setCsoundPlayState("playing"));
                            _context5.next = 33;
                            break;
                        case 24:
                            _context5.prev = 24;
                            _context5.next = 27;
                            return csoundObj.cleanup();
                        case 27:
                            _context5.next = 32;
                            break;
                        case 29:
                            _context5.prev = 29;
                            _context5.t0 = _context5["catch"](24);
                            console.error(_context5.t0);
                        case 32:
                            dispatch(setCsoundPlayState("error"));
                        case 33:
                        case "end":
                            return _context5.stop();
                    }
            }, _callee5, null, [[24, 29]]);
        }));
        return function (_x6, _x7) {
            return _ref7.apply(this, arguments);
        };
    }();
};
export var stopCsound = function stopCsound() {
    csoundInstance && csoundInstance.stop();
    return setCsoundPlayState("stopped");
};
export var pauseCsound = function pauseCsound() {
    csoundInstance && csoundInstance.pause();
    return setCsoundPlayState("paused");
};
export var resumePausedCsound = function resumePausedCsound() {
    csoundInstance && csoundInstance.resume();
    return setCsoundPlayState("playing");
};
export var renderToDisk = function renderToDisk(setConsole) {
    return /*#__PURE__*/ function () {
        var _ref8 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee7(dispatch) {
            var state, project, targetDocumentUid, Csound, csound, filesPre, targetDocumentName, outputName, result;
            return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1)
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            state = store.getState();
                            project = selectActiveProject(state);
                            if (project) {
                                dispatch(cleanupNonCloudFiles({
                                    projectUid: project.projectUid
                                }));
                            }
                            if (project) {
                                _context7.next = 6;
                                break;
                            }
                            dispatch(openSnackbar("Render error: no project is currently selected", SnackbarType.Error));
                            return _context7.abrupt("return");
                        case 6:
                            targetDocumentUid = getSelectedTargetDocumentUid(project.projectUid, state);
                            if (targetDocumentUid) {
                                _context7.next = 10;
                                break;
                            }
                            dispatch(openSnackbar("Render error: no target was found for this project", SnackbarType.Error));
                            return _context7.abrupt("return");
                        case 10:
                            Csound = Csound6; // const Csound = useCsound7 ? Csound7 : Csound6;
                            // vanilla mode should work everywhere
                            _context7.next = 13;
                            return Csound({
                                useWorker: true
                            });
                        case 13:
                            csound = _context7.sent;
                            csoundInstance = csound;
                            if (csound) {
                                _context7.next = 18;
                                break;
                            }
                            dispatch(openSnackbar("Render error: csound failed to start", SnackbarType.Error));
                            return _context7.abrupt("return");
                        case 18:
                            setConsole([""]);
                            csound.on("message", function (message) {
                                return setConsole(append(message + "\n"));
                            });
                            _context7.next = 22;
                            return syncFs(csound, project.projectUid, state);
                        case 22:
                            _context7.next = 24;
                            return csound.fs.readdir("/");
                        case 24:
                            filesPre = _context7.sent;
                            targetDocumentName = project.documents[targetDocumentUid].filename;
                            if (!targetDocumentName.endsWith("csd")) {
                                _context7.next = 31;
                                break;
                            }
                            _context7.next = 29;
                            return csound.compileCsd(targetDocumentName);
                        case 29:
                            _context7.next = 33;
                            break;
                        case 31:
                            _context7.next = 33;
                            return csound.compileOrc(project.documents[targetDocumentUid].currentValue);
                        case 33:
                            _context7.next = 35;
                            return csound.getOutputName();
                        case 35:
                            outputName = _context7.sent;
                            if (!(typeof outputName !== "string" || outputName.length === 0 || outputName === "dac")) {
                                _context7.next = 40;
                                break;
                            }
                            outputName = "".concat(targetDocumentName.split(".")[0], ".wav");
                            _context7.next = 40;
                            return csound.setOption("-o".concat(outputName));
                        case 40:
                            csound.once("renderStarted", function () {
                                dispatch(setCsoundPlayState("rendering"));
                                dispatch(openSnackbar("Render of ".concat(targetDocumentName, " started"), SnackbarType.Info));
                            });
                            csound.once("renderEnded", /*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee6() {
                                var filesPost, newFiles, _iterator3, _step3, newFile, buffer;
                                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                                    while (1)
                                        switch (_context6.prev = _context6.next) {
                                            case 0:
                                                _context6.next = 2;
                                                return csound.cleanup();
                                            case 2:
                                                _context6.next = 4;
                                                return csound.fs.readdir("/");
                                            case 4:
                                                filesPost = _context6.sent;
                                                newFiles = difference(filesPost, filesPre);
                                                _iterator3 = _createForOfIteratorHelper(newFiles);
                                                _context6.prev = 7;
                                                _iterator3.s();
                                            case 9:
                                                if ((_step3 = _iterator3.n()).done) {
                                                    _context6.next = 17;
                                                    break;
                                                }
                                                newFile = _step3.value;
                                                _context6.next = 13;
                                                return csound.fs.readFile(newFile);
                                            case 13:
                                                buffer = _context6.sent;
                                                if (buffer) {
                                                    nonCloudFiles.set(newFile, {
                                                        buffer: buffer,
                                                        createdAt: new Date(),
                                                        name: newFile
                                                    });
                                                    dispatch(addNonCloudFile({
                                                        createdAt: Date.now(),
                                                        name: newFile
                                                    }));
                                                }
                                            case 15:
                                                _context6.next = 9;
                                                break;
                                            case 17:
                                                _context6.next = 22;
                                                break;
                                            case 19:
                                                _context6.prev = 19;
                                                _context6.t0 = _context6["catch"](7);
                                                _iterator3.e(_context6.t0);
                                            case 22:
                                                _context6.prev = 22;
                                                _iterator3.f();
                                                return _context6.finish(22);
                                            case 25:
                                                _context6.next = 27;
                                                return syncFs(csound, project.projectUid, state);
                                            case 27:
                                                _context6.prev = 27;
                                                _context6.next = 30;
                                                return csound.terminateInstance();
                                            case 30:
                                                _context6.next = 34;
                                                break;
                                            case 32:
                                                _context6.prev = 32;
                                                _context6.t1 = _context6["catch"](27);
                                            case 34:
                                                dispatch(setCsoundPlayState("stopped"));
                                                dispatch(openSnackbar("Render of ".concat(targetDocumentName, " done"), SnackbarType.Success));
                                            case 36:
                                            case "end":
                                                return _context6.stop();
                                        }
                                }, _callee6, null, [[7, 19, 22, 25], [27, 32]]);
                            })));
                            _context7.next = 44;
                            return csound.start();
                        case 44:
                            result = _context7.sent;
                            if (result !== 0) {
                                dispatch(openSnackbar("Render error: the project encountered an error while rendering", SnackbarType.Error));
                            }
                            dispatch(setCsoundPlayState("stopped"));
                            _context7.next = 49;
                            return csound.stop();
                        case 49:
                        case "end":
                            return _context7.stop();
                    }
            }, _callee7);
        }));
        return function (_x8) {
            return _ref8.apply(this, arguments);
        };
    }();
};
